"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListItemIcon = exports.StyledMenuItemBase = void 0;
var ListItemIcon_1 = __importDefault(require("../ListItemIcon"));
var styles_1 = require("@mui/material/styles");
var MenuItemBase_1 = __importDefault(require("./MenuItemBase"));
var colors_1 = require("../ThemeProvider/colors");
exports.StyledMenuItemBase = (0, styles_1.styled)(MenuItemBase_1.default)(function (_a) {
    var variant = _a.variant;
    return (__assign(__assign(__assign({}, (variant === 'check' && {
        minWidth: 284,
        border: '2px solid transparent',
        paddingRight: '12px',
        '&.Mui-selected': {
            color: colors_1.tannerSemantic.info.color,
            backgroundColor: colors_1.tannerSemantic['info']['background'],
            '&:hover': { backgroundColor: '#CBDEF8' },
        },
        '+.MuiDivider-root': {
            marginTop: '6px',
        },
    })), (variant === 'danger' && {
        '&:not(.Mui-disabled)': {
            color: colors_1.tannerDanger['light'],
            '&:hover': {
                backgroundColor: colors_1.tannerDanger['main'],
            },
            '&:focus-visible': {
                backgroundColor: colors_1.tannerDanger['main'],
            },
        },
    })), { '.MuiCheckbox-root': {
            padding: '0px',
            height: '18px',
            width: '18px',
        }, '.Mui-disabled': {
            color: colors_1.tannerGray[600],
            fontSize: '14px',
            fontWeight: '400',
        } }));
});
exports.StyledListItemIcon = (0, styles_1.styled)(ListItemIcon_1.default)({
    color: 'inherit',
    fontSize: '17px',
    marginRight: '-12px',
    marginLeft: '4px',
});
//# sourceMappingURL=styles.js.map